import { render, staticRenderFns } from "./ResourceList.vue?vue&type=template&id=2cbd7383&scoped=true"
import script from "./ResourceList.vue?vue&type=script&lang=js"
export * from "./ResourceList.vue?vue&type=script&lang=js"
import style0 from "./ResourceList.vue?vue&type=style&index=0&id=2cbd7383&prod&lang=less&scoped=true"
import style1 from "./ResourceList.vue?vue&type=style&index=1&id=2cbd7383&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd7383",
  null
  
)

export default component.exports